
import {BANNER} from './BannerTypes'

export const changeBanner = banner => {
    return {
        type: BANNER,
        load: banner
    }
}
export const selectNewBanner = (banner) => {

    return (dispatch) => {
        dispatch(changeBanner(banner))
    }

}